import { FAILURE, REQUEST, SUCCESS } from '@/constants/mutation-types';

export default key =>
  [FAILURE, REQUEST, SUCCESS].reduce(
    (acc, type) => ({ ...acc, [type]: `${key}/${type}` }),
    {},
  );
